import React from 'react';
import { motion } from 'framer-motion';
import { FileSignature, UserCheck, Award, Calendar, Shield, Sparkles, ArrowRight } from 'lucide-react';
const reasons = [{
  icon: FileSignature,
  title: 'Fixed Price Promise',
  body: 'Whatever we quote on the kitchen table is what you pay. No day of install surprises. No variations on the day.'
}, {
  icon: UserCheck,
  title: 'Mike Quotes Every Job Personally',
  body: 'Not a sales rep. Not a subcontractor. The owner walks your home, measures up, and recommends honestly.'
}, {
  icon: Award,
  title: 'Mitsubishi Electric Diamond Dealer',
  body: 'The highest tier of Mitsubishi installer accreditation in Australia. We are tested on installation quality every year.'
}, {
  icon: Calendar,
  title: '30+ Years, Same Family',
  body: 'Founded 1995, family run from Balcatta. We answer our phone and we still install across Perth every week.'
}, {
  icon: Shield,
  title: 'Workmanship Guarantee',
  body: 'If anything we installed fails because of our workmanship, you call us. We come back free.'
}, {
  icon: Sparkles,
  title: 'Clean Install Promise',
  body: 'Drop sheets down. Vacuum on departure. We treat your home like ours.'
}];
export function WhyLangler() {
  return <section className="bg-cream py-20 md:py-28 scroll-mt-24" data-id="element-791">
      <div className="max-w-6xl mx-auto px-6" data-id="element-792">
        <div className="max-w-3xl mb-14" data-id="element-793">
          <div className="kicker mb-3" data-id="element-794">Why Langler Air</div>
          <h2 className="text-3xl md:text-5xl font-bold text-ink-900 tracking-tight leading-tight" data-id="element-795">
            Six things most Perth installers will not tell you.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-796">
          {reasons.map((reason, i) => {
          const Icon = reason.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.06
          }} className="lift-card bg-white rounded-2xl p-7 border border-stone-200" data-id="element-797">
                <div className="w-12 h-12 rounded-xl bg-brand-soft text-brand flex items-center justify-center mb-5" data-id="element-798">
                  <Icon size={22} strokeWidth={2} data-id="element-799" />
                </div>
                <h3 className="text-xl font-extrabold text-ink-900 tracking-tight leading-tight mb-3" data-id="element-800">
                  {reason.title}
                </h3>
                <p className="text-sm text-stone-600 leading-relaxed" data-id="element-801">
                  {reason.body}
                </p>
              </motion.div>;
        })}
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-between gap-6 pt-8 border-t border-stone-200" data-id="element-802">
          <div className="text-sm text-stone-600" data-id="element-803">
            Related:{' '}
            <a href="/ducted-air-conditioning/" className="text-brand font-semibold hover:underline" data-id="element-804">
              Ducted Reverse Cycle Installation
            </a>{' '}
            ·{' '}
            <a href="/smart-zone/" className="text-brand font-semibold hover:underline" data-id="element-805">
              Smart Zone Control
            </a>{' '}
            ·{' '}
            <a href="/brand/mitsubishi-air-conditioner-perth/" className="text-brand font-semibold hover:underline" data-id="element-806">
              Mitsubishi Electric
            </a>
          </div>
          <a href="#quote-form" className="inline-flex items-center gap-2 text-brand font-semibold hover:underline" data-id="element-807">
            Get my free quote <ArrowRight size={14} data-id="element-808" />
          </a>
        </div>
      </div>
    </section>;
}